// extracted by css-extract-rspack-plugin
export default {"headerRow":"qnRRIUwbem4B1xHd","left":"A3GibrPDIKs7jfu2","projectCount":"LwnbZ0Y08kLBvPCd","dropdown":"Qnu2uRtPWykjKadY"};